import { render, staticRenderFns } from "./KttHandDialog.vue?vue&type=template&id=586a64da&scoped=true"
import script from "./KttHandDialog.vue?vue&type=script&lang=js"
export * from "./KttHandDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586a64da",
  null
  
)

export default component.exports